import { Space, Text } from "@/atoms"
import { Heading } from "@/molecules/Heading"
import { Item, List } from "@/pages/DiscoveryPage/components/molecules/List"
import { Fragment } from "react"
import { BaseImageFixesList } from "./BaseImageFixesList"
import { findingsToBaseImageSources } from "./utils"

import type { BaseImageFinding, BaseImageFix } from "@/domain/issue"
import type { BaseCardComponentProps } from "../../../RemediationGuide.types"

import styles from "./BaseImageFixes.module.scss"

export const BaseImageFixes: React.FC<
  BaseCardComponentProps & {
    baseImageFindings: BaseImageFinding[]
    copyable?: boolean
  }
> = ({ baseImageFindings, copyable, t, tKey }) => {
  const baseImageSources = findingsToBaseImageSources(baseImageFindings)
  const allBaseImageFixes: BaseImageFix[] = baseImageSources
    .map((f) => f.remedies)
    .flat()
  const hasFixes = allBaseImageFixes.length > 0
  const hasSingleBaseImages = baseImageSources.length === 1

  return (
    <Space orientation="vertical">
      {!hasFixes ? (
        <>
          <Heading level={6} title={`${t(`${tKey}baseImageUpdate`)}:`} />
          <div className={styles.noFixContainer}>
            <Text>{t(`${tKey}undeterminedBaseImageFix`)}</Text>
            <Text>{t(`${tKey}undeterminedBaseImageFix2`)}</Text>
          </div>
        </>
      ) : (
        <>
          <Heading
            level={6}
            title={`${t(`${tKey}updateBaseImage`, { count: baseImageSources.length })}:`}
          />
          {hasSingleBaseImages ? (
            <BaseImageFixesList
              fixes={baseImageSources[0].remedies}
              copyable={copyable}
              t={t}
            />
          ) : (
            <List
              limit={copyable ? undefined : 2}
              items={baseImageSources}
              Component="ol"
              classes={{ list: styles.sourcesList }}
              render={({ tag, remedies }, index) => (
                <Fragment key={index}>
                  <Item
                    title={tag}
                    classes={{
                      item: styles.baseSourceItem,
                      title: styles.baseSourceTitle
                    }}
                  />
                  <BaseImageFixesList
                    fixes={remedies}
                    copyable={copyable}
                    t={t}
                  />
                </Fragment>
              )}
            />
          )}
        </>
      )}
    </Space>
  )
}
